// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YsL7","footer":"styles_footer__1QgA8","passCodeTooltip":"styles_passCodeTooltip__1-U-P"};